import { PageHero, CtaSection } from "../components/Sections";
import Seo from "../components/Seo";
import { PROCESS, APPROACH, IMAGES, PAGE_SEO } from "../lib/data";

export default function Process() {
  return (
    <>
      <Seo {...PAGE_SEO.process} />
      <PageHero
        crumb="Process"
        image={IMAGES.process}
        eyebrow="How We Work"
        title="A process built around"
        accent="your operation"
        sub="No black boxes. No scope creep surprises. A clear path from current state to measurable results — with you involved at every milestone."
      />

      {/* STEPS */}
      <section id="process" style={{ background: "white" }}>
        <div className="s-inner">
          <div className="steps">
            {PROCESS.map((step, i) => (
              <div className={`step fade-up ${i ? "d" + i : ""}`} key={step.n}>
                <div className="step-bubble">{step.n}</div>
                <h4>{step.title}</h4>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRINCIPLES */}
      <section id="services">
        <div className="s-inner">
          <div className="fade-up" style={{ marginBottom: 48, maxWidth: 640 }}>
            <span className="s-eye">Our Principles</span>
            <h2>How we tackle issues differently</h2>
            <p className="s-lead">The methodology behind every engagement — the reason our recommendations stick and our results hold up.</p>
          </div>
          <div className="approach-list">
            {APPROACH.map((a, i) => (
              <div className={`approach-item fade-up ${i ? "d1" : ""}`} key={a.title}>
                <div className="approach-num">{String(i + 1).padStart(2, "0")}</div>
                <div className="approach-body">
                  <h4>{a.title}</h4>
                  <p>{a.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHAT TO EXPECT */}
      <section id="stats" style={{ background: "var(--off-white)" }}>
        <div className="s-inner">
          <div className="fade-up" style={{ textAlign: "center", marginBottom: 48 }}>
            <span className="s-eye">What To Expect</span>
            <h2 style={{ color: "var(--text-dark)" }}>Clear deliverables at every stage</h2>
            <p className="s-lead" style={{ margin: "0 auto" }}>You always know what's coming next and how to measure whether it worked.</p>
          </div>
          <div className="value-grid fade-up d1">
            <div className="value-card">
              <h4>A Prioritized Roadmap</h4>
              <p>A clear 30/60/90-day plan with specific recommendations, owners, and expected impact — not a 100-page report that sits on a shelf.</p>
            </div>
            <div className="value-card">
              <h4>Hands-On Execution</h4>
              <p>We don't just advise — we configure, test, document, and support go-live alongside your team until results are realized.</p>
            </div>
            <div className="value-card">
              <h4>Knowledge Transfer</h4>
              <p>We leave your team stronger than we found it, with documentation and training so improvements stick long after we're gone.</p>
            </div>
          </div>
        </div>
      </section>

      <CtaSection
        eyebrow="Start The Process"
        title="It begins with one"
        accent="honest conversation."
        lead="Step one is a free 60-minute discovery call — no sales pitch, just a practical assessment of where you are and where you could be."
      />
    </>
  );
}
